import React from 'react'
import { useLocation } from 'react-router-dom'
import { Stack } from '@mui/material'
import { Navigate } from 'router'
import { useUser } from 'store'
import { AppWrapper } from './AuthenticatedLayoutStyles'
import Sidebar from './Sidebar'
import Header from './Header'
import { SidebarProvider } from 'components/AuthenticatedLayout/Sidebar/SidebarContext'
import { BreadcrumbActionProvider } from './Header/components/BreadcrumbActions'
import SupportPhoneAlert from './SupportPhoneAlert'

const AuthenticatedLayout = ({ children }) => {
  return (
    <SidebarProvider>
      <BreadcrumbActionProvider>
        <AppWrapper variant="center">
          <Stack direction={'row'} gap={0} sx={{ height: '100dvh', overflow: 'hidden' }}>
            <Sidebar />
            <Stack
              py={0}
              pr={0}
              pl={0}
              flex={1}
              sx={{
                height: '100%',
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
                '&::-webkit-scrollbar': {
                  display: 'none'
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
              }}
            >
              <Stack gap={0} flex={1} sx={{ height: '100%', minHeight: 0 }}>

                <Header />
                <Stack px={3.5} pt={0} pb={2} flex={1} minHeight={0}>
                  {children}
                </Stack>
              </Stack>

            </Stack>
          </Stack>
        </AppWrapper>
        <SupportPhoneAlert />
      </BreadcrumbActionProvider>
    </SidebarProvider>
  )
}

export default (props) => {
  const { pathname } = useLocation()
  const [user] = useUser()
  if (!user && localStorage.getItem('ACCESS_TOKEN')) {
    return <Navigate pathname={'/auth/me'} search={{ redirect: pathname }} />
  } else if (!user) {
    return <Navigate pathname={'/auth/login'} />
  }
  return <AuthenticatedLayout {...props} />
}
